<template>
  <div class="section" :data-section-idx="section.idx" :data-section-label="section.label" :class="{'has-sirah': section.isSirah, 'show-sirah': showSirah, selected}">
    <div class="section-inner" v-observe-visibility="{callback: visible => sectionVisibilityChanged(visible, section.idx)}">
      <div class="section-text">
        <span v-if="debugSections">{{ section.idx }}</span>
        <div class="section-text--lines" dir="rtl">
          <SectionLineContainer
            v-for="line in lines"
            :key="line.idx"
            :selected-line="selectedLine"
            :selected-token="selectedToken"
            :alignments-map="alignmentsMap"
            :reader-id="readerId"
            :line="line"
            :debug="debugSections"
            @scrollToElement="element => $emit('scrollToElement', element)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    SET_READER_VISIBLE_SECTION,
    TOGGLE_SHOW_SIRAH,
  } from '../../constants';
  import SectionLineContainer from './SectionLineContainer.vue';

  export default {
    props: ['work', 'section', 'selectedSection', 'alignmentsMap', 'readerId', 'selectedLine', 'selectedToken'],
    components: { SectionLineContainer },
    watch: {
      selected: {
        immediate: true,
        handler() {
          if (this.selected && !(Number.isInteger(this.selectedLine))) {
            this.$nextTick(() => {
              this.$emit('scrollToElement', this.$el);
            });
          }
        },
      },
    },
    methods: {
      onShowSirah() {
        this.$store.dispatch(TOGGLE_SHOW_SIRAH);
      },
      alignments(line) {
        return this.alignmentsMap[line.idx] || [];
      },
      sectionVisibilityChanged(visible, sectionIdx) {
        if (sectionIdx && visible) {
          // @@@ consider modifying reader in state.readers, but unsure of reactivity
          this.$store.dispatch(SET_READER_VISIBLE_SECTION, { readerId: this.readerId, sectionIdx });
        }
      },
    },
    computed: {
      selected() {
        return this.section.idx === this.selectedSection;
      },
      lines() {
        return this.section.lines;
      },
      showSirah() {
        return this.$store.state.showSirah;
      },
      alignmentsUrl() {
        return this.section.alignments_url;
      },
      debugSections() {
        return (process.env.VUE_APP_DAR_DEBUG_SECTIONS === '1');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../variables.scss";
  .sirah-indicator {
    color: $entity-color-14;
    background: #EFEFEF;
    text-align: right;
  }

  // this is a hack required because the Arabic character, أ, extends beyond the bounds of the div.
  // https://share.getcloudapp.com/o0ugOldb
  .section {
    padding-top: 12px;
  }

  .section-label {
      color: #666;
      text-align: center;
      margin: 5px 0;
  }
  .section-loading {
    min-height: 200px;
  }
  .section-text {
    display: flex;
    .section-text--lines {
      flex: 1;
      text-align: right;
    }
  }
</style>
